<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      :loading="loading"
      :disable="loading"
      :options.sync="options"
      :server-items-length="totalCount"
    >
      <template #[`item.statusId`]="{item}">
        <v-chip
          small
          :outlined="getOrderStatusColor(item.statusId).outlined"
          :color="getOrderStatusColor(item.statusId).color"
          :dark="getOrderStatusColor(item.statusId).dark"
        >{{item.statusId}}</v-chip>
      </template>
      <template #[`item.buildStatus`]="{item}">
        <v-chip
          v-if="item.buildStatus"
          small
          :outlined="getBuildStatusColor(item.buildStatus).outlined"
          :color="getBuildStatusColor(item.buildStatus).color"
          :dark="getBuildStatusColor(item.buildStatus).dark"
        >{{item.buildStatus}}</v-chip>
      </template>
      <template #[`item.invoice.id`]="{item}">
      {{item.invoiceNumber}}
      </template>
      
      <template #[`item.shopId`]="{item}">
      {{item.shop.name}}
      </template>

      <template #[`item.clientId`]="{item}">
      {{item.client.displayName}}
      </template>
      
      <template #[`item.clubFitterId`]="{item}">
      {{item.clubFitter ? item.clubFitter.displayName : '-'}}
      </template>


      <template v-slot:item.actions="{item}">
        <v-btn v-if="item.statusId == 'new'" small color="error" outlined @click="doDelete(item.id)" class="mr-2">
          Delete
        </v-btn>
        <v-btn small outlined @click="open(item.id)">
          View
        </v-btn>
      </template>
    </v-data-table>
    <ConfirmBox ref="confirm" />
  </div>
</template>

<script>
import _ from "lodash";
import {mapActions, mapGetters} from 'vuex';
import hasQueryParams from '../../mixins/hasQueryParams.vue';
import ConfirmBox from "../ui/ConfirmBox.vue";
export default {
  name: 'orderTable',
  components: {ConfirmBox},
  mixins: [hasQueryParams],
  data: () => ({
    initialized:false,
    tableData: [],
    totalCount: 0,
    loading: null,
    options: { page:1, itemsPerPage: 15, sortBy: ["validationDate"], sortDesc: [false] },
    headers: [
      { text: "Id", value: "id", align: "left" },
      { text: "Shop", value: "shopId", align: "left" },
      { text: "Customer", value: "clientId", align: "left"},
      { text: "Status", value: "statusId", align: "left", bgcolor: null },
      { text: "Build Status", value: "buildStatus",align: "left", sortable:false  },
      { text: "Club Fitter", value: "clubFitterId", bgcolor: null },
      { text: 'Validation Date', value:"validationDate", align:"left" },
      { text: "Actions", value: "actions", sortable:false }
    ],
    queryFields: ['page', 'itemsPerPage', 'orderSortBy', 'sortDesc']
  }),
  props: {
    status: {
      type: String
    },
    clientId:{
      type: Number
    },
    shopId:{
      type: Number
    }
  },
  computed:{
    ...mapGetters("auth", ["currentUser"]),
    query () {
      return {
        page: this.options.page.toString(),
        itemsPerPage: this.options.itemsPerPage.toString(),
        orderSortBy: this.options.sortBy.toString(),
        sortDesc: this.options.sortDesc.toString()
      }
    }
  },
  mounted: function() {
    this.init()
    this.fetchOrders();
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        if(this.initialized){
          this.fetchOrders();
        }
      }, 100)
    },
    shopId:{
      handler: _.debounce(function() {
        this.fetchOrders();
      }, 100)
    }
  },
  methods: {
    ...mapActions("orders",{deleteOrder: "delete", getOrders:'index'}),
    init(){
      this.parseQuery()
      this.initialized=true
    },
    parseQuery(){
      this.options = {
        ...this.options,
        page: this.$route.query.page ? parseInt(this.$route.query.page): 1,
        itemsPerPage: this.$route.query.itemsPerPage ? parseInt(this.$route.query.itemsPerPage): 15,
        sortBy: this.getSortFromQuery(),
        sortDesc: [this.$route.query.sortDesc === 'false' ? false : true]
      }
    },
    getSortFromQuery() {
      const sort = this.$route.query.orderSortBy
      if(sort && this.headers.find(h => h.value == sort)){
        return [sort]
      }
      return ["validationDate"]
    },

    getOrderStatusColor(status){
      switch (status) {
        case 'open':
          return {
            color: 'orange',
            outlined: true,
            dark:false,
          }
        case 'close':
          return {
            color: 'green',
            outlined: false,
            dark:true
          }
        case 'cancel':
          return {
            color: 'red',
            outlined: true,
            dark:false,
          }
        default:
          return {
            color: 'blue-grey darken-1',
            outlined: true,
            dark:false,
          }
      }
    },

    getBuildStatusColor(status){
      switch (status) {
        case 'open':
          return {
            color: 'orange',
            outlined: true,
            dark:false,
          }
        case 'shipped':
          return {
            color: 'green',
            outlined: false,
            dark:true,
          }
        case 'cancel':
          return {
            color: 'red',
            outlined: true,
            dark:false,
          }
        default:
          return {
            color: 'blue-grey darken-1',
            outlined: true,
            dark:false,
          }
      }
    },
    fetchOrders() {
      this.loading = true;
      let filters = {};
      if (this.status) {
        filters.statusId = this.status;
      }
      if (this.clientId) {
        filters.clientId = this.clientId;
      }
      if (this.shopId) {
        filters.shopId = this.shopId;
      }
      this.pushNewRoute()

      this.getOrders({
          pagination: this.options,
          filters: filters
        })
        .then(({orders}) => {
          this.tableData = orders.data;
          this.totalCount = orders.total
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open(id) {
      this.$router.push("/orders/view/" + id);
    },
    openInvoice(id) {
      this.$router.push("/orders/print/" + id);
    },
    async doDelete(id){
      if(await this.$refs.confirm.open("Are you sure to want delete this order ?", "All information of this order will be delete and prescription are unquoted")){
        this.deleteOrder(id)
          .then((data) => {
            this.fetchOrders();
            this.flashMessage.success({
              message: data.message,
            });
          })
          .catch(({data}) => {
            console.log(data)
            this.flashMessage.error({
              message: data.message,
            });
          })
      }
      
    }
  }
};
</script>

<style>
</style>